import { SessionRepository } from "../../infra/repository/session.repository";
import { SessionModel } from "../domain/session";

export class GetSessionUseCase {
    static async execute(sessionId: string): Promise<SessionModel> {
        try {
            const response = await SessionRepository.getSession(sessionId);
            if (response?.error) throw new Error("Erro ao obter sessão");
            const { id, name, qrcode, workoutId, link } = response.data;
            return new SessionModel(id, name, qrcode, workoutId, link ?? "");
        } catch {
            throw new Error("Erro ao obter sessão");
        }
    }
}
